import i18next from 'i18next';

const LanguageHelper = {
  /**
   * Lay ngon ngu hien tai
   */
  getCurrentLanguage: () => {
    return i18next.language;
  },

  /**
   * Doi ngon ngu
   * @param {string} langCode ma ngon ngu
   */
  changeLanguage: async (langCode, callback) => {
    await i18next.changeLanguage(langCode, callback);
  },
};

export default LanguageHelper;
